import { fetchRoomKolList, RoomKolListQueryParamsType } from '@/api/fetchRoomKolList'
import { QUERY_KEY } from '@/constants/queryKey'
import { useQuery } from 'react-query'

type UseRoomKolListQueryProps = RoomKolListQueryParamsType

const useRoomKolListQuery = ({ roomId, status = 1 }: UseRoomKolListQueryProps) => {
  const query = useQuery(
    [QUERY_KEY.FETCH_FOLLOWERS, { roomId, status }],
    () =>
      fetchRoomKolList({
        roomId,
        status,
      }),
    {
      enabled: !!roomId,
    },
  )
  return { ...query }
}

export default useRoomKolListQuery
